import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import CheckIcon from "@mui/icons-material/Check";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";

import { AlertContext } from "../../../context/AlertContext";
import { AuthContext } from "../../../context/AuthContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { getBrand, createBrandTheme } from "../../../theme/brand";
import Spinner from "../Spinner";
import Barra from "../Barra";
import CabeceraPantalla from "../common/CabeceraPantalla";

export default function NumeroInterno() {
  const { mensajeAlerta } = useContext(AlertContext);
  const { state, usuarioAutenticado } = useContext(AuthContext);
  const { statusAcceso, configuracion, obtenerAcceso } =
    useContext(ConfiguracionContext);

  const [numeroInterno, setNumeroInterno] = useState(0);
  const navigate = useNavigate();
  const theme = createBrandTheme(getBrand(configuracion));

  useEffect(() => {
    usuarioAutenticado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "NumeroInterno" });
    }
    if (localStorage.getItem("numeroInterno") !== null) {
      setNumeroInterno(localStorage.getItem("numeroInterno"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (statusAcceso === 400) {
      mensajeAlerta(
        "Accesos",
        "No tiene permiso para acceder a esta pantalla !.",
        "error",
      );
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusAcceso]);

  const aceptarClick = (e) => {
    e.preventDefault();
    if (Number(numeroInterno) === 0) {
      mensajeAlerta(
        "Configuración",
        "El número de interno es necesario !.",
        "error",
      );
      return;
    }
    localStorage.setItem("numeroInterno", numeroInterno);
    mensajeAlerta("Configuración", "Número de interno guardado.", "success");
  };

  const exitClick = () => navigate("/");

  return (
    <Fragment>
      <Barra />

      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}

      {statusAcceso === 200 ? (
        <ThemeProvider theme={theme}>
          <Box sx={{ px: { xs: 1, sm: 2 }, pb: 3, maxWidth: 720, mx: "auto" }}>
            <CabeceraPantalla
              icono={<PhoneOutlinedIcon />}
              titulo="Número de interno telefónico"
              subtitulo="Se guarda en este equipo"
              onCerrar={exitClick}
            />

            <Paper
              elevation={0}
              sx={{
                p: 3,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="numeroInterno"
                    name="numeroInterno"
                    label="Número de interno"
                    fullWidth
                    required
                    type="number"
                    value={numeroInterno}
                    onChange={(e) => setNumeroInterno(e.target.value)}
                  />
                </Grid>
              </Grid>

              <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  startIcon={<CheckIcon />}
                  onClick={aceptarClick}
                >
                  Aceptar
                </Button>
                <Button variant="text" color="inherit" onClick={exitClick}>
                  Cancelar
                </Button>
              </Stack>
            </Paper>
          </Box>
        </ThemeProvider>
      ) : null}
    </Fragment>
  );
}
